<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("tipo-veiculo") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t("despesas") }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'des-tipo-veiculo' })">{{
                                        $t("tipo-veiculo")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'des-tipo-veiculo' })"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving || tipoVeiculo.situacao == 0"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div>
                    <div class="columns">
                        <div class="column is-6" style="height: 65px !important">
                            <v-input
                                ref="descricaoInput"
                                v-model="tipoVeiculo.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                :title="'descricao'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!tipoVeiculo.descricao"
                                uppercase
                                :required="true"
                            />
                        </div>
                        <div class="column is-3">
                            <label>{{ $t("icone") }}</label>
                            <IconsSelect
                                @changeIcon="changeIcon"
                                ref="iconeInput"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="invalidIcon"
                                :iconClass="tipoVeiculo.icone"
                :icons="icons"
                            ></IconsSelect>
                        </div>
                        <div class="column is-3">
                            <label for="color">{{ $t("selecione-uma-cor") }}</label>
                            <color-picker
                                id="cor"
                                type="text"
                                :color="tipoVeiculo.cor"
                                ref="cpInput"
                                @colorpicked="colorpicked"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoVeiculoService from "@/services/despesas/TipoVeiculoService";
import TipoVeiculoValidation from "@/services/validations/despesas/TipoVeiculoValidation";
import IconsSelect from "@/components/shared/form/IconsSelect";
import ColorPicker from "@/components/shared/form/ColorPicker";
import Message from "@/models/Message";

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    data() {
        return {
            variaveis: [],
            service: new TipoVeiculoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: null,
            tipoVeiculo: {
                idtipoveiculo: null,
                descricao: null,
                icone: "",
                cor: "#D0CFCF",
            },
            invalidIcon: false,
            teste: [],
            isUpdate: false,
            icons: [
                { pack: "fas", class: "car-side" },
                { pack: "fas", class: "truck" },
                { pack: "fas", class: "truck-pickup" },
                { pack: "fas", class: "truck-moving" },
                { pack: "fas", class: "shuttle-van" },
                { pack: "fas", class: "truck-monster" },
                { pack: "fas", class: "motorcycle" },
                { pack: "fas", class: "plane" },
                { pack: "fas", class: "bus" },
                { pack: "fas", class: "ship" },
                { pack: "fas", class: "subway" },
                { pack: "fas", class: "taxi" },
            ]
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "tipo-veiculo"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tipo-veiculo" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }

        this.validation = new TipoVeiculoValidation(this.msgs);
    },
    methods: {
    changeIcon(icon) {
            this.tipoVeiculo.icone = icon;
        },
        colorpicked(color) {
            this.tipoVeiculo.cor = color;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then(value => {
                    this.tipoVeiculo = value.content;
                })
                .catch(e => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (
                this.validation.validate(this.tipoVeiculo, this.$refs) &&
                this.tipoVeiculo.icone != ""
            ) {
                let tipoVeiculoTemp = Object.assign({}, this.tipoVeiculo);
                tipoVeiculoTemp = this.mapTosave(tipoVeiculoTemp);

                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(tipoVeiculoTemp)
                    .then(value => {
                        if (value.message == null) {
                            let msg = "msg-save-tipo-veiculo";
                            if (this.tipoVeiculo.idtipoVeiculo != null) {
                                msg = "msg-edit-tipo-veiculo";
                            }
                            this.msgs.push(new Message("success", msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message("alert", value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.msgs.push(
                                new Message("alert", "msg-existe-descricao-tipo-veiculo", true)
                            );
                        } else {
                            this.msgs.push(new Message("error", "msg-erro-load", true));
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.tipoVeiculo.icone == ""
                    ? (this.invalidIcon = true)
                    : (this.invalidIcon = false);
                this.isLoading = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "des-tipo-veiculo",
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
